import {Component, Input} from '@angular/core';
import {Message} from '../../../contracts/message.interface';

@Component({
  standalone: true,
  selector: 'app-message-text',
  imports: [],
  templateUrl: './message-text.component.html',
  styleUrl: './message-text.component.scss'
})
export class MessageTextComponent {
  @Input() message!: Message;
}
